module.exports = __webpack_public_path__ + "static/img/M2SSD-D-Tyyskw.c55f2a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/M2SSD-D-Tyyskw.png
// module id = FxgP
// module chunks = 16